import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const AMLPolicy = () => {
  return (
    <div>
      <Navbar />
       <section className="in_page p70 bg4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h1 className="hadding">AML Policy</h1>
              <p>Dyntech is committed to preventing the platform from being used for money laundering, terrorist financing, and other financial crimes. This policy outlines our KYC, transaction monitoring, and reporting procedures.</p>
            </div>
            <div className="col-md-4 col-lg-3 m-auto">
              <img
                src="/img/aml-policy.png"
                alt="AML Policy"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
       <section className="in_page p70 bg2">
        <div className="container">
          <h3 className="mb-3"><b>Customer Due Diligence (CDD)</b></h3>
          <h5 className="mb-3"><b>1. Identification & Verification:</b></h5>
         
          <ul className="list mb-4 mb-md-5">
            <li> Collect government ID, proof of address, and beneficial ownership details for entities.</li> 
            <li>Perform electronic and document-based verification checks. </li> 
          </ul>

           <h5 className="mb-3"><b>2. Risk Assessment:</b></h5>
         
          <ul className="list mb-4 mb-md-5">
            <li>Classify clients as Low, Medium, or High risk based on jurisdiction, transaction volume, and business type. </li> 
            <li> Apply Enhanced Due Diligence (EDD) for high-risk clients or politically exposed persons (PEPs).</li> 
          </ul>
          
  <h3 className="mb-3"><b>Ongoing Monitoring</b></h3>
      <ul className="list mb-4 mb-md-5">
            <li><b>Transaction Surveillance:</b> Automated systems flag large, rapid, or unusual transactions.</li> 
            <li><b>Periodic Reviews:</b> Re-verify customer information annually or upon significant account activity.</li> 
          </ul> 
 
   <h3 className="mb-3"><b>Reporting Suspicious Activity</b></h3>
      <ul className="list mb-4 mb-md-5">
            <li><b>Internal Escalation:</b> AML team reviews alerts and escalates credible concerns.</li> 
            <li><b>Regulatory Filing:</b> File Suspicious Activity Reports (SARs) with relevant authorities in the client’s jurisdiction.</li> 
          </ul> 

   
      
  </div>
      </section>
         <section className="in_page p70 ">
           <div className="container">
              <h3 className="mb-3"><b>Record-Keeping</b></h3>
              <p>We retain KYC documentation, transaction logs, and AML review notes for a minimum of five years, in line with global regulatory requirements.</p>
               <h3 className="mb-3"><b>Training & Compliance</b></h3>
              <p>All employees undergo annual AML training. Our Compliance Officer oversees policy enforcement, updates, and regulatory liaison.</p>
           </div>
         </section>
      <Footer />
    </div>
  );
};

export default AMLPolicy;
